import { motion } from "framer-motion";
import { fileUrl } from "@/lib/api";

const FALLBACK = [
  { id: "d1", title: "Modernes Wohnzimmer", image_path: null, fallback: "https://images.pexels.com/photos/13141770/pexels-photo-13141770.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200" },
  { id: "d2", title: "Neuer Anstrich Schlafzimmer", image_path: null, fallback: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d3", title: "Fassadenarbeit", image_path: null, fallback: "https://images.pexels.com/photos/1669754/pexels-photo-1669754.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200" },
];

export default function Gallery({ items }) {
  const displayItems = items && items.length > 0 ? items : FALLBACK;

  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 sm:py-32 bg-sand-200">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.25em] text-sage font-bold mb-6" data-testid="gallery-overline">Unsere Galerie</p>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-stone-900 leading-tight" data-testid="gallery-headline">
              Räume, in denen Farbe <em>erzählt</em>.
            </h2>
          </div>
          {items?.length === 0 && (
            <p className="text-sm text-stone-600 italic max-w-sm" data-testid="gallery-placeholder-note">
              Bald ergänzen wir hier eigene Fotos unserer aktuellen Projekte.
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {displayItems.map((item, idx) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: (idx % 3) * 0.1 }}
              data-testid={`gallery-item-${idx}`}
              className={`relative overflow-hidden rounded-sm group ${idx % 5 === 0 ? "lg:row-span-2 aspect-[3/4] lg:aspect-auto" : "aspect-[4/3]"}`}
            >
              <img
                src={item.image_path ? fileUrl(item.image_path) : item.fallback}
                alt={item.title || "Projektbild"}
                className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105"
              />
              {item.title && (
                <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-stone-900/80 to-transparent">
                  <p className="text-sand-100 font-display text-xl" data-testid={`gallery-item-title-${idx}`}>{item.title}</p>
                  {item.description && <p className="text-sand-100/80 text-sm mt-1">{item.description}</p>}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
